import React, { useState } from 'react';
import {
  CssBaseline,
  Paper,
  ThemeProvider,
  createTheme,
  responsiveFontSizes,
} from '@mui/material';
import { createBreakpoints } from '@mui/system';
import { Element } from 'react-scroll';
import './App.css';

import { customizations } from './Theme';
import Navbar from './Components/Navbar';
import Home from './Pages/Home';
import About from './Pages/About';
import Skills from './Pages/Skills';
import Projects from './Pages/Projects';
import ContactMe from './Pages/ContactMe';
import Footer from './Pages/Footer';

function App() {
  // For toggling theme (Dark || Light)
  const [mode, setMode] = useState('light');

  // Custom theme template
  const breakpoints = createBreakpoints({});
  let theme = createTheme(customizations(mode, breakpoints));
  theme = responsiveFontSizes(theme);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Paper
        style={{ borderRadius: 0, minHeight: '100vh', minWidth: '100vw' }}
        elevation={0}
      >
        <div className='App'>
          <Navbar mode={mode} setMode={setMode} />
          <Element name='home'>
            <Home />
          </Element>
          <Element name='about'>
            <About />
          </Element>
          <Element name='skills'>
            <Skills />
          </Element>
          <Element name='projects'>
            <Projects />
          </Element>
          <Element name='contact'>
            <ContactMe />
          </Element>
          <Footer />
        </div>
      </Paper>
    </ThemeProvider>
  );
}

export default App;
